import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import type { UserType } from '../types';

export type RateLimitFeatureKey =
  | 'chat'
  | 'conversation'
  | 'vehicle'
  | 'grounding'
  | 'multimodal:image'
  | 'multimodal:audio'
  | 'multimodal:video'
  | 'refinePrice'
  | 'masterMode'
  | 'sanayiRaporu:session'
  | 'sanayiRaporu:bilgiToplama'
  | 'sanayiRaporu:ozet'
  | 'sanayiRaporu:raporOlustur'
  | 'sanayiRaporu:media:image'
  | 'sanayiRaporu:media:audio'
  | 'sanayiRaporu:media:video'
  | 'sanayiRaporu:ustaArama';

export interface RateLimitFeatureStatus {
  key: RateLimitFeatureKey;
  label: string;
  used: number;
  limit: number;
  requiresPremium: boolean;
  unit: string;
  type: 'daily' | 'total';
}

export interface MonthlyRateLimitFeatureStatus {
  key: RateLimitFeatureKey;
  label: string;
  used: number;
  limit: number;
  requiresPremium: boolean;
  unit: string;
  type: 'monthly' | 'total';
}

export interface RateLimitStatusResponse {
  userType: UserType;
  date: string;
  features: RateLimitFeatureStatus[];
  config?: {
    masterModeLocked: boolean;
  };
}

interface RateLimitStatusRequest {
  userType?: UserType;
}

export interface MonthlyRateLimitStatusResponse {
  userType: UserType;
  periodKey: string;
  periodStartsAt: string;
  periodEndsAt: string;
  windowType: 'calendar' | 'premium_cycle';
  features: MonthlyRateLimitFeatureStatus[];
  config?: {
    masterModeLocked: boolean;
  };
}

const getRateLimitStatusFn = httpsCallable<RateLimitStatusRequest | undefined, RateLimitStatusResponse>(
  functions,
  'getRateLimitStatus'
);

const getMonthlyRateLimitStatusFn = httpsCallable<
  RateLimitStatusRequest | undefined,
  MonthlyRateLimitStatusResponse
>(
  functions,
  'getMonthlyRateLimitStatus'
);

export async function fetchRateLimitStatus(userType?: UserType): Promise<RateLimitStatusResponse> {
  const response = await getRateLimitStatusFn(userType ? { userType } : undefined);
  return response.data;
}

export async function fetchMonthlyRateLimitStatus(
  userType?: UserType
): Promise<MonthlyRateLimitStatusResponse> {
  const response = await getMonthlyRateLimitStatusFn(userType ? { userType } : undefined);
  return response.data;
}
